import { render, staticRenderFns } from "./product-attribute.vue?vue&type=template&id=68f491fe&scoped=true&"
import script from "./product-attribute.vue?vue&type=script&lang=js&"
export * from "./product-attribute.vue?vue&type=script&lang=js&"
import style0 from "./product-attribute.vue?vue&type=style&index=0&id=68f491fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f491fe",
  null
  
)

export default component.exports